import i18n from '@lib/i18n';

// expose this for reactifi and perhaps courses to use as well
window.i18nDashiFi = i18n;
